import AspectWrapper from "core-web/components/AspectWrapper";
import BleedWrapper from "theme/components/wrappers/BleedWrapper";
import styled from "theme/libs/styled";

const ImageBox = styled("div")`
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.darkGreige};
`;

const MediaGallery = () => {
    return (
        <BleedWrapper paddingRight={["0", null, null, null, "32px"]}>
            <AspectWrapper ratio={1}>
                <ImageBox />
            </AspectWrapper>
        </BleedWrapper>
    );
};

export default MediaGallery;
